import React, { useState, useEffect } from "react";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Snackbar from "../snackbar";
// import UploadButton from "./UploadButton";
// import UploadStatus from "./UploadStatus";
import _ from "lodash";
import { Create, TopToolbar, ListButton, useTranslate } from "react-admin";
import { useLocation, useNavigate } from "react-router-dom";

const ClickItUserCreate = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  // props.location.query.order_number
  const [enableSave, setEnableSave] = useState(false);

  //   const [noOrderFound, setNoOrderFound] = useState(true);
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  //   const [business, setBusiness] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [businessId, setBusinessId] = useState({});
  const [onSaveDisabled, setOnSaveDisabled] = useState(false);

  const [formSettings, setFormSettings] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");

  const [businessError, setBusinessError] = useState(false);
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [phoneErrorMsg, setPhoneErrorMsg] = useState(null);

  const [emailError, setEmailError] = useState(false);

  const [similarNumberError, setSimilarNumberError] = useState(false);
  const [similarNumberMsg, setSimilarNumberMsg] = useState("");

  const [similarEmailError, setSimilarEmailError] = useState(false);
  const [similarEmailMsg, setSimilarEmailMsg] = useState("");

  const [businessRole, setBusinessRole] = useState({});
  const [businessRoleError, setBusinessRoleError] = useState(false);
  const rolesOption = [
    { value: "contract_person", label: "Contract Person" },
    { value: "owner", label: "Owner" },
    { value: "view_only", label: "View Only"}
  ];
  const [contractListOption, setContractListOption] = useState([]);
  const [contractList, setContractList] = useState([]);
  const [contractError, setContractError] = useState(false);

  useEffect(() => {
    // const { location } = props;

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/so_business_list`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;

        setSaleOffNameSapCode(
          obj.sap_order_materials.map((item) => ({
            id: item.id,
            value: item.label,
            label: item.label,
            sap_code: item.sap_code.trim(),
          }))
        );
        // if ("state" in location) {
        //   const businessId = location.state;
        //   const filteredBusiness = obj.sap_order_materials.filter(
        //     (data) => data.id === businessId
        //   );
        //   setBusinessId(filteredBusiness[0]);
        //   setBusinessError(false);
        // }

        // setOriginalList(
        //   obj.sap_order_materials.map((item) => ({
        //     id: item.id,
        //     value: item.label,
        //     label: item.label,
        //     sap: item.sap_code.trim(),
        //   }))
        // );
      });
  }, []);

  useEffect(() => {
    if (
      Object.keys(businessId).length > 0 &&
      Object.keys(businessRole).length > 0 &&
      businessRole.value == "contract_person"
    ) {
      setContractListOption([]);
      console.log("uspppppppppp", businessId);
      const ids = businessId.map((item) => item.id);
      console.log(ids);
      const encodedIds = encodeURIComponent(JSON.stringify(ids));
      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      options.method = "GET";
      fetch(`${apiUrl}/get_contracts_list?business_ids=${encodedIds}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("jsonD ===>", jsonD);
          if (jsonD.contracts.length > 0) {
            let obj = {};
            // obj.contracts = jsonD.data;
            obj.loadingShow = false;

            setContractListOption(
              jsonD.contracts.map((item) => ({
                id: item.id,
                value: item.label,
                label: item.label,
                sap_code: item.sap_code.trim(),
              }))
            );
          }
        });
    }
  }, [businessId, businessRole]);

  const handleChangeContracts = (e) => {
    console.log("hiiii", e);
    setContractError(false);
    setContractList(e);
    // console.log("saleOffNameSapCode in handleChange", saleOffNameSapCode);
    // const arr = [...originalList];

    // let result =
    //   arr &&
    //   arr.filter(
    //     (item) => [e] && [e].filter((i) => i.id === item.id).length === 0
    //   );
    // console.log("////", result);
    // if ([e] === null) {
    //   result = [...originalList];
    //   setBusiness([]);
    // }
    // setBusiness([e]);
    // setSaleOffNameSapCode(result);
  };

  const cancelClick = () => {
    // setBusiness([]);
    setBusinessId({});
    setBusinessError(true);
    // setSaleOffNameSapCode(originalList);
  };

  const handleChangeRole = (e) => {
    console.log("hiiii", e);
    setBusinessRoleError(false);
    setBusinessRole(e);
    setContractList([]);
  };

  const handleChange = (e) => {
    console.log("hiiii", e, contractList);
    if (e.length > 0 && contractList.length > 0) {
      const sapSet = new Set(e.map((item) => item.sap_code));
      // Filter the second array based on whether the sap value exists in the first array
      const filteredSecondArray = contractList.filter((item) =>
        sapSet.has(item.sap_code)
      );
      setContractList(filteredSecondArray);
      console.log("filteredSecondArray ", filteredSecondArray);
    }

    setBusinessError(false);
    setBusinessId(e);
  };

  const changeFirstName = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setFirstNameError(true);
    } else {
      setFirstNameError(false);
    }
    setFirstName(positionObject);
  };

  const changeLastName = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setLastNameError(true);
    } else {
      setLastNameError(false);
    }
    setLastName(positionObject);
  };

  const changePhoneNumber = (event) => {
    const pattern = new RegExp(/^[0-9\b]+$/);
    const reg = new RegExp("^d+$");
    setSimilarNumberError(false);
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length ||
      reg.test(positionObject)
    ) {
      setPhoneNumberError(true);
      setPhoneErrorMsg("Enter Phone number");
    } else {
      setPhoneNumberError(false);
      setPhoneErrorMsg(null);
    }
    setPhoneNumber(positionObject);
  };

  const changeEmail = (event) => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    setSimilarEmailError(false);
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length ||
      !pattern.test(positionObject)
    ) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    setEmail(positionObject);
  };

  const changeAddress = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      //   setProductDescriptionError(true);
    } else {
      //   setProductDescriptionError(false);
    }
    setAddress(positionObject);
  };

  const sumbitForm = () => {
    // const splitBusinessId = business[0].id;
    if (phoneNumber.length < 7 || phoneNumber.length > 15) {
      setPhoneNumberError(true);
      setPhoneErrorMsg("Phone number should be min 7 and max 15 digit");
    } else {
      setPhoneNumberError(false);
      setPhoneErrorMsg(null);
      setOnSaveDisabled(true);
      const stateData = localStorage.getItem("__state");
      const userData = stateData ? JSON.parse(stateData) : false;

      const formData = new FormData();
      // formData.append('business', splitBusinessId)
      formData.append(
        "business_id",
        JSON.stringify(businessId.map((a) => a.id))
      );
      formData.append("email", email);
      formData.append("phone", phoneNumber);
      formData.append("first_name", firstName);
      formData.append("last_name", lastName);
      formData.append("role_name", businessRole.value);
      formData.append("contract_list", JSON.stringify(contractList));
      // formData.append("address", address);
      // const targetUrl = `${props.user._links.business.href}/proof_of_payments`;
      // props.addProofOfPay({ targetUrl, formData });
      const options = CommonHeaderOption();
      const apiUrl = RUN_TIME_API_ENDPOINT;
      options.method = "POST";

      for (var key of formData.entries()) {
        console.log(key[0] + ", " + key[1]);
      }
      console.log(
        "business_id",
        businessId.map((a) => a.id)
      );

      options.body = formData;
      fetch(`${apiUrl}/users`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: userData._token,
        },
      })
      .then(async (res) => {
        let json = {};

        try {
          const responseText = await res.text();
          json = responseText ? JSON.parse(responseText) : {};
        } catch (error) {
          console.error("Unable to parse API response:", error);
        }

        return {
          status: res.status,
          json,
        };
      })
      .then(({ status, json }) => {
        switch (status) {
          case 400:
          case 409:
            if (json.type === "Phone") {
              setSimilarNumberError(true);
              setSimilarNumberMsg(json.message || "Phone number already exists");
            } else {
              setSimilarEmailError(true);
              setSimilarEmailMsg(json.message || "Email already exists");
            }
            break;

          case 200:
          case 201:
          case 204:
            setShowSnackbar(true);

            setTimeout(() => {
              navigate(-1);
            }, 1000);
            break;

          default:
            console.error("User creation failed:", status, json);
            break;
        }
      })
      .catch((error) => {
        console.error("Create user API error:", error);
      })
      .finally(() => {
        setOnSaveDisabled(false);
      });
    }
  };

  useEffect(() => {
    const formSetting = JSON.parse(localStorage.getItem("__state"));
    setFormSettings(formSetting.proof_of_payment_form);
  }, []);

  // console.log('business id offfffffff', businessId);

  const CreateActions = ({ basePath, data }) => (
    <TopToolbar>
      <ListButton basePath={basePath} />
    </TopToolbar>
  );
  const translate = useTranslate();

  // {translate('resources.users.fields.updated_by_id')}
  return formSettings ? (
    <Create
      actions={<CreateActions />}
      title={translate("resources.users.fields.create_user")}
      {...props}
    >
      <div className="so-form">
        <div>
          <label className="select-label">
            {translate("resources.users.fields.role")}
            <sup>*</sup>
          </label>
          <div className="select-retailer">
            <Select
              // value={businessRole}
              onChange={handleChangeRole}
              options={rolesOption}
              isMulti={false}
              required={true}
              IndicatorsContainer={true}
            />
            {/* <button onClick={cancelClick}>{translate('resources.users.fields.clear')}</button> */}
          </div>
          {businessRoleError && (
            <p className="so-input-error">Enter Business Role</p>
          )}
        </div>
        <div>
          <label className="select-label">
            {translate("resources.users.fields.sold_to")}
            <sup>*</sup>
          </label>
          <div className="select-retailer">
            <Select
              // value={businessId}
              onChange={handleChange}
              options={saleOffNameSapCode}
              isMulti={true}
              required={true}
              IndicatorsContainer={true}
            />
            {/* <button onClick={cancelClick}>{translate('resources.users.fields.clear')}</button> */}
          </div>
          {businessError && <p className="so-input-error">Enter Business Id</p>}
        </div>

        {Object.keys(businessId).length > 0 &&
          Object.keys(businessRole).length > 0 &&
          businessRole.value == "contract_person" && (
            <div>
              <label className="select-label">
                {translate("resources.users.fields.contracts")}
                <sup>*</sup>
              </label>
              <div className="select-retailer">
                <Select
                  value={contractList}
                  onChange={handleChangeContracts}
                  options={contractListOption}
                  isMulti={true}
                  required={true}
                  IndicatorsContainer={true}
                />
                {/* <button onClick={cancelClick}>{translate('resources.users.fields.clear')}</button> */}
              </div>
              {contractError && (
                <p className="so-input-error">Enter Contracts</p>
              )}
            </div>
          )}

        <div className="so-input">
          <label>
            {translate("resources.users.fields.first_name")}
            <sup>*</sup>
          </label>
          <input type="text" value={firstName} onChange={changeFirstName} />
          {firstNameError && <p className="so-input-error">Enter first name</p>}
        </div>

        <div className="so-input">
          <label>
            {translate("resources.users.fields.last_name")}
            <sup>*</sup>
          </label>
          <input type="text" value={lastName} onChange={changeLastName} />
          {lastNameError && <p className="so-input-error">Enter Last name</p>}
        </div>

        <div className="so-input">
          <label>
            {translate("resources.users.fields.phone")}
            <sup>*</sup>
          </label>
          <input
            type="number"
            min="0"
            maxLength="18"
            value={phoneNumber}
            onChange={changePhoneNumber}
          />
          {phoneNumberError && (
            <p className="so-input-error">{phoneErrorMsg}</p>
          )}

          {similarNumberError && (
            <p className="so-input-error">{similarNumberMsg}</p>
          )}
        </div>

        <div className="so-input">
          <label>
            {translate("resources.users.fields.email")}
            <sup>*</sup>
          </label>
          <input type="email" value={email} onChange={changeEmail} />
          {emailError && <p className="so-input-error">Enter Email</p>}

          {similarEmailError && (
            <p className="so-input-error">{similarEmailMsg}</p>
          )}
        </div>

        {/* <div className="so-input">
          <label>Address
          </label>
<textarea
              className="inapp-notification-description"
              name="description"
              maxLength="340"
              value={address}
              onChange={changeAddress}
            />
        </div> */}

        <div></div>
        <div className="so-save-button">
          <button
            onClick={sumbitForm}
            disabled={
              onSaveDisabled ||
              !firstName ||
              !lastName ||
              !phoneNumber ||
              !email ||
              !Object.keys(businessId).length ||
              !Object.keys(businessRole).length ||
              businessRole.value == 'contract_person' && !Object.keys(contractList).length ||
              emailError
            }
          >
            {onSaveDisabled ? (
              <>
                <span className="custom-save-spinner" />
                Saving...
              </>
            ) : (
              <span>{translate("resources.users.fields.save")}</span>
            )}
          </button>
        </div>
        {showSnackbar && <Snackbar message="Element Created" />}
      </div>
    </Create>
  ) : (
    <div>loading</div>
  );
};

export default ClickItUserCreate;
